import { buildImageURL } from '../../helpers';

export const IMAGES = [
  buildImageURL('/s6-1.jpg'),
  buildImageURL('/s6-2.jpg'),
  buildImageURL('/s6-3.png'),
  buildImageURL('/s6-4.jpg'),
  buildImageURL('/s6-5.jpg'),
  buildImageURL('/s6-6.jpg')
];
